import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { Colors } from '../../styles/theme';

interface FeatureCardProps {
  title: string;
  description: string;
  // Make image optional if not always present, or ensure a default
  image?: string; // Changed to optional as the car image might be dynamic
}

const FeatureCard: FC<FeatureCardProps> = ({ title, description, image }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: {
          xs: '540px',
          sm: '640px',
          md: '780px',
        },
        borderRadius: '20px',
        backgroundImage: `
  linear-gradient(
    180deg,
    rgba(188, 221, 255, 1) 28%,
    rgba(188, 221, 255, 0) 55%
  ),
    url(${image}),
  linear-gradient(#E9E9E9, #E9E9E9)
`,

        backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
        backgroundPosition: 'center bottom, center bottom, center bottom',
        backgroundSize: '100% 100%, 100% auto, 100% 100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          paddingTop: {
            xs: '16px',
            sm: '70px',
            md: '70px',
          },
          paddingRight: {
            xs: '16px',
            sm: '46px',
            md: '46px',
          },
          paddingBottom: {
            xs: '16px',
            sm: '46px',
            md: '46px',
          },
          paddingLeft: {
            xs: '16px',
            sm: '46px',
            md: '46px',
          },
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          spacing: '24px',
        }}
      >
        <Typography
          fontWeight={600}
          fontSize={{
            xs: 24,
            sm: 28,
            md: 32,
          }}
          sx={{
            color: Colors.black,
          }}
        >
          {title}
        </Typography>
        <Typography
          fontWeight={400}
          fontSize={{
            xs: 14,
            sm: 18,
            md: 20,
          }}
          sx={{
            color: Colors.blackAlpha70,
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default FeatureCard;
